import useFetchRoleDescriptions from "../../common/roles/useFetchRoleDescriptions";

export const FetchRoleDescriptionsInitializer = () => {
	useFetchRoleDescriptions();

	return null;
};
